import { Link } from 'gatsby';
import { default as React } from 'react';
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
  PoweredBy,
} from 'react-instantsearch-dom';

const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits;

  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount} {hitCount !== 1 ? `resultaten` : `resultaat`} gevonden
    </div>
  ) : null;
});

const typeToPathPrefix = {
  page: 'over-csv',
  post: 'nieuws',
};

const PageHit = ({ hit }) => (
  <div>
    <Link to={`${typeToPathPrefix[hit._type] || ''}/${hit.slug.current}`}>
      <h4>
        <Highlight attribute="title" hit={hit} tagName="mark" />
      </h4>
    </Link>
    {/* <Snippet attribute="_rawBody.children.text" hit={hit} tagName="mark" /> */}
    <Snippet attribute="summary" hit={hit} tagName="mark" />
  </div>
);

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <HitCount />
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
);

const SearchResult = ({ indices, className }) => (
  <div className={className}>
    {indices.map(index => (
      <HitsInIndex index={index} key={index.name} />
    ))}
    <PoweredBy />
  </div>
);

export default SearchResult;
